import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/helpers/api-helper";
import userApi from "@infrastructure/user-api";
export const createUserAsync = createAsyncThunk("users/create", async (command, { rejectWithValue }) => {
    try {
        const response = await userApi.createUser(command);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserAsync = createAsyncThunk("users/update", async (command, { rejectWithValue }) => {
    try {
        const response = await userApi.updateUser(command);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllUsersAsync = createAsyncThunk("users/getAll", async (query, { rejectWithValue }) => {
    try {
        const response = await userApi.getAll(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserByIdAsync = createAsyncThunk("users/getById", async (query, { rejectWithValue }) => {
    try {
        const response = await userApi.getById(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUsersByProposalAsync = createAsyncThunk("users/getByDesignation", async (designationId, { rejectWithValue }) => {
    try {
        const response = await userApi.getUsersByDesignation(designationId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserStatusAsync = createAsyncThunk("users/updateStatus", async (command, { rejectWithValue }) => {
    try {
        await userApi.updateStatus(command);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateMultipleUserStatusAsync = createAsyncThunk("users/updateMultipleStatus", async (command, { rejectWithValue }) => {
    try {
        await userApi.updateMultipleStatus(command);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
